import { render, staticRenderFns } from "./Incredient.vue?vue&type=template&id=15c47860&scoped=true&"
import script from "./Incredient.vue?vue&type=script&lang=ts&"
export * from "./Incredient.vue?vue&type=script&lang=ts&"
import style0 from "./Incredient.vue?vue&type=style&index=0&id=15c47860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c47860",
  null
  
)

export default component.exports